const doubles = [
  ['2340', '2350'],
  ['3100', '3110', '3120', '3160'],
  ['4040', '4050']
];
export default doubles;
